export const PLANS_VIEW_NAME = 'Planes';
export const FREQUENT_QUESTIONS_VIEW_NAME = 'Preguntas frecuentes';
export const TERMS_AND_CONDITIONS_VIEW_NAME = 'Términos y condiciones';
export const LEGAL_NOTICES_VIEW_NAME = 'Avisos legales';
export const CONTACT_US_VIEW_NAME = 'Contáctanos';
export const HIRE_PLAN_VIEW_NAME = 'Contratación de plan';
export const DATA_PRIVACY_TERMS_VIEW_NAME = 'Términos de tratamiento de data personal';
